import styled from "styled-components";

export const Banner = styled.div<{ src: string }>`
  background-image: url(${({ src }) => src});

  width: 100%;
  height: 12rem;
  border-radius: 1rem;
  margin-top: 0.5rem;
  z-index: 2;
`;
